import React from 'react'
import Popover from '@mui/material/Popover'
import ColorPicker from 'components/ColorPicker/Picker'
import {palette} from 'utils/enums/colors'

export default ({target, style, onToggle, handleClose}) => {
	const onClick = (data) => {
		const color = data.hex
		onToggle(color)
	}

    return (
		<Popover
			open={true}
			anchorEl={target}
			onClose={handleClose}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'center',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'center',
			}}
			PaperProps={{
				style: {
					padding: '15px'
				}}
			}
		>
			<ColorPicker
				color={style ? style.color : ''}
				palette={palette}
				onChange={onClick}
			/>
		</Popover>
    )
}
